<template>
  <div class="borrowerAttributeMultiSelect">
    <BorrowerAttributeConstructor
      :questionText="questionText"
      :description="description"
      :descriptionTooltip="descriptionTooltip"
      :label="label"
      :tooltipText="tooltipText"
      :errorText="errorText"
      :helpText="helpText"
      :disclaimer="disclaimer">
      <template v-slot:input>
        <multiselect
          v-model="selectedObjects"
          :id="'ba' + question.id"
          :name="'ba' + question.id"
          :data-cy="question.alias"
          :class="{'is-invalid': v$.selectedObjects && v$.selectedObjects.$invalid && v$.selectedObjects.$dirty}"
          :options="question.options"
          :multiple="true"
          :close-on-select="false"
          :disabled="disabled"
          :placeholder="placeholderMessage"
          label="label"
          track-by="value"
          @close="onChange(v$.selectedObjects, selectedObjects); onBlur(v$.selectedObjects)"
          @remove="onChange(v$.selectedObjects, selectedObjects)"
        >
        </multiselect>
      </template>
    </BorrowerAttributeConstructor>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'
  import { useVuelidate } from '@vuelidate/core'
  import { required } from '@vuelidate/validators'
  import split from 'lodash/split'
  import get from 'lodash/get'
  import BorrowerAttributeConstructor from './BorrowerAttributeConstructor.vue'
  export default {
    components: {
      Multiselect,
      BorrowerAttributeConstructor,
    },
    setup: () => ({ v$: useVuelidate() }),
    data () {
      return {
        selected: null,
        selectedObjects: [],
        placeholderMessage: '',
        errorMessage: 'This field is required',
        placeholderOptions: ['apple', 'banana', 'orange', 'peach', 'watermelon', 'pineapple', 'grapes']
      }
    },
    props: {
      question: Object,
      disabled: Boolean,
      v: Object
    },
    emits: ['invalidity','answer'],
    created () {
      this.$watch('invalid', (invalid) => {
        this.$emit('invalidity', invalid)
      }, {immediate: true})

      if (this.question.value) {
        let values = split(this.question.value, ',')
        for (var i = 0; i < values.length; i++) {
          this.populateExistingAnswers(values[i], this.question.options)
        }
      }
    },
    computed: {
      invalid() {
        return this.v$.$invalid
      },
      questionText() {
        return this.question.questionText || ''
      },
      description() {
        return this.question.description || ''
      },
      descriptionTooltip() {
        return this.question.descriptionTooltip || ''
      },
      label() {
        return this.question.name || ''
      },
      tooltipText() {
        return this.question.tooltip || this.question.helpText || ''
      },
      helpText() {
        return this.question.tooltip ? this.question.helpText : ''
      },
      errorText() {
        return get(this.v$, 'selectedObjects.$error') ? this.errorMessage : ''
      },
      disclaimer() {
        return this.question.disclaimer || ''
      },
    },
    methods: {
      onChange (v$, e) {
        if (!v$.invalid) {
          v$.$touch()
        }
        const updatedAnswer = {
          value: v$.$model.map((selection) => selection.value).join(),
          isInvalid: v$.$error,
        }
        this.$emit('answer', updatedAnswer)
      },
      onBlur (v$) {
        v$.$touch()
      },
      populateExistingAnswers (existingValue, questionsArray) {
        for (var i = 0; i < questionsArray.length; i++) {
          if (questionsArray[i].value === existingValue) {
            this.selectedObjects.push(questionsArray[i])
          }
        }
      }
    },
    validations: {
      selectedObjects: {
        required
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import 'vue-multiselect/dist/vue-multiselect.css';

  .multiselect--active {
    z-index: 999;
  }

  .multiselect__tag {
    background: $blue;
    margin-bottom: 0;
  }

  .multiselect__select {
    height: 40px;
  }

  .multiselect__tag-icon:after {
    color: #fff;
  }

  .multiselect__tags {
    border-color: $border-100;
  }

  .multiselect__option--selected.multiselect__option--highlight, .multiselect__option--selected.multiselect__option--highlight::after  {
    background: darken($blue, 5%);
  }

  .multiselect__option--selected, .multiselect__option--selected::after {
    background: $blue;
    color: white;
  }

  .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
    background: darken($blue, 5%);
  }

  .multiselect__option--highlight {
    background: $background-100;
    color: black;
    font-weight: bold;
    &::after {
      background: $background-100;
      color: black;
      font-weight: bold;
    }
  }

  .multiselect.is-invalid {
    .multiselect__tags {
      border-color: $red-300;
    }
  }
</style>
